import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
  Box, Card, CardContent, Typography, Stack, Button, IconButton, Tooltip, Chip,
} from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import MicRoundedIcon from '@mui/icons-material/MicRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import AddHomeWorkRoundedIcon from '@mui/icons-material/AddHomeWorkRounded';
import { Link, useNavigate } from 'react-router-dom';
import { getBearerToken, putBearerToken } from '../../utils/Apis';
import AppShell from '../../layouts/AppShell';

const A_room_list = () => {
  const navigate = useNavigate();
  const [rows, setrows] = React.useState([]);
  const [rendered, setrendered] = useState(0);

  React.useEffect(() => {
    fetch_users();
  }, [rendered]);

  const editAdmin = async (id, type) => {
    if (type == 'E') {
      navigate('/edit_room', { state: { id: id } });
    } else {
      const confirmDelete = window.confirm('Are you sure you want to delete this Room?');

      if (!confirmDelete) return;
      putBearerToken('room', { _id: id, deleted_at: new Date() }).then((result) => {
        if (result.error == 0) {
          setrendered((o) => o + 1);
        } else {
          //
        }
      });
    }
  };

  const fetch_users = async () => {
    getBearerToken('room').then((result) => {
      if (result.error == 0) {
        console.log(result.data);
        setrows(result.data);
      } else {
        // notify(JSON.stringify(result.messages))
      }
    });
  };

  const columns = [
    { field: 'name', headerName: 'Name', flex: 1, minWidth: 140 },
    { field: 'password', headerName: 'Password', flex: 1, minWidth: 120 },
    {
      field: 'link', headerName: 'Link', flex: 1, minWidth: 100, sortable: false, filterable: false,
      renderCell: (params) => (
        <Button
          size="small"
          variant="outlined"
          component="a"
          target="_blank"
          href={params.row?.room_data?.join_url}
          startIcon={<OpenInNewRoundedIcon fontSize="small" />}
        >
          LINK
        </Button>
      ),
    },
    {
      field: 'host', headerName: 'Host', flex: 1, minWidth: 120,
      renderCell: (params) => params.row?.host_of_room?.slug_name,
    },
    {
      field: 'is_active', headerName: 'Status', flex: 1, minWidth: 110,
      renderCell: (params) => (
        <Chip
          size="small"
          variant="outlined"
          color={params.row.is_active == true ? 'success' : 'error'}
          label={params.row.is_active == true ? 'Active' : 'Inactive'}
        />
      ),
    },
    {
      field: 'action', headerName: 'Action', flex: 3, minWidth: 220, sortable: false, filterable: false,
      renderCell: (params) => (
        <Stack direction="row" spacing={0.5} alignItems="center">
          <Tooltip title="Start">
            <IconButton size="small" color="success" component={Link} to={'/meeting/host/' + params.row._id} target="_blank">
              <VideocamRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <IconButton size="small" color="primary" onClick={() => editAdmin(params.row._id, 'E')}>
              <EditRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton size="small" color="error" onClick={() => editAdmin(params.row._id, 'D')}>
              <DeleteOutlineRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Users">
            <IconButton size="small" color="primary" component={Link} to={'/active_user_list/' + params.row._id} target="_blank">
              <GroupRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Audios">
            <IconButton size="small" color="primary" component={Link} to={'/cloud_recordings'} target="_blank">
              <MicRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  return (
    <AppShell title="Room Management" breadcrumb={['Rooms']}>
      <Card>
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h4">Rooms</Typography>
            <Button sx={{ ml: 'auto' }} variant="contained" startIcon={<AddHomeWorkRoundedIcon />} onClick={() => navigate('/create_room')}>
              Add Room
            </Button>
          </Stack>
          <Box sx={{ width: '100%' }}>
            <DataGrid
              autoHeight
              rows={rows}
              columns={columns}
              getRowId={(data) => data._id}
              disableRowSelectionOnClick
              initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
              pageSizeOptions={[10, 25, 50]}
              sx={{ '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': { outline: 'none' } }}
            />
          </Box>
        </CardContent>
      </Card>
    </AppShell>
  );
};

export default A_room_list;
